import { z } from 'zod';
import { COLLABORATION_CATEGORIES, COLLABORATION_TYPES } from '../constant';

export const CollaborationCategoryEnum = z.enum(COLLABORATION_CATEGORIES);

export const CollaborationTypeEnum = z.enum(COLLABORATION_TYPES);

export const CollaborationFormSchema = z
  .object({
    creator_name: z.string().min(1, '크리에이터 이름은 필수입니다.'),
    collaboration_types: z.array(CollaborationTypeEnum).min(1, '하나 이상의 제안 종류를 선택해야 합니다.'),
    category: CollaborationCategoryEnum,
    category_etc: z.string().optional(),
    proposal_content: z
      .string()
      .min(1, '제안 내용을 입력해주세요.')
      .max(2000, '제안 내용은 최대 2000자까지 작성가능합니다.'),
    brand_name: z.string().min(1, '브랜드명을 입력해주세요.'),
    brand_url: z
      .string()
      // .url('올바른 URL 형식이 아닙니다.')
      .min(1, '브랜드 URL을 입력해주세요.'),
    manager_name: z.string().min(1, '담당자 성함을 입력해주세요.'),
    manager_tel: z.string().min(1, '담당자 연락처를 입력해주세요.'),
    manager_email: z
      .string()
      // .email('이메일 형식이 올바르지 않습니다.')
      .min(1, '담당자 이메일을 입력해주세요.'),
  })
  .superRefine((data, ctx) => {
    if (data.category === '기타' && (!data.category_etc || data.category_etc.trim() === '')) {
      ctx.addIssue({
        path: ['category_etc'],
        code: z.ZodIssueCode.custom,
        message: '기타를 선택한 경우 상세 카테고리를 입력해주세요.',
      });
    }
  });
